
export default {
	name: 'AppMain',
	key(route) {
		return route.path
	}
}
